<template>
  <div class="tickeprice-list">
    <Row>
      <Col>
        <Button @click="showModel()" type="success" class="f-r">添加</Button>
      </Col>
    </Row>
    <Table border :columns="list" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Modal
      v-model="showModalStatus"
      :title="title"
      @on-ok="createOrUpdate('dataInfoValidate')"
      :loading="loading"
    >
      <Form
        :model="dataInfo"
        ref="dataInfoValidate"
        :rules="dataInfoValidate"
        action="javascript:void(0)"
      >
        <FormItem label="选择分类">
          <Select v-model="dataInfo.type_id" filterable clearable>
            <Option v-for="item in typeList" :value="item.id" :key="item.id">{{ item.title }}</Option>
          </Select>
        </FormItem>
        <FormItem label="票价" prop="price">
          <Input v-model="dataInfo.price" placeholder="请输入票价..."></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "tickeprice-list",
  data() {
    return {
      loading: true,
      dataloading: true,
      typeList: [],
      title: "",
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      formItem: {
        key: ""
      },
      list: [
        {
          title: "Id",
          key: "id",
          fixed: "left",
          width: 90
        },
        {
          title: "门票类型",
          key: "type",
          minWidth: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.tickettype == "" ? "" : params.row.tickettype.title
              )
            ]);
          }
        },
        {
          title: "票价",
          key: "price"
        },
        {
          title: "操作",
          key: "action",
          width: 150,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      dataInfo: {
        price: "0",
        type_id: "0"
      },
      showModalStatus: false,
      dataInfoValidate: {
        price: [{ required: true, message: "票价必须填写", trigger: "blur" }]
      }
    };
  },
  // 组件
  components: {},
  created: function() {
    this.ticket_id = this.$route.params.id;
    this.$api.smarttickettype.list({ size: 9999 }).then(res => {
      if (res.code == 200) {
        this.typeList = res.result.list;
      }
    });
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function() {
      this.$api.smartticketprice
        .list({
          page: this.pages.page,
          size: this.pages.size,
          ticket_id: this.ticket_id
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
    },
    // 展开添加
    showModel() {
      this.title = "添加";
      this.dataInfo = {
        price: "0",
        type_id: "0"
      };
      this.showModalStatus = !this.showModalStatus;
    },
    // 详情
    detail(index, id) {
      this.title = "编辑";
      this.dataInfo = {
        price: "0",
        type_id: "0"
      };
      this.showModalStatus = !this.showModalStatus;
      this.$api.smartticketprice.detail({ id: id }).then(res => {
        this.dataInfo = res.result;
        this.dataInfo.price = res.result.price.toString();
      });
    },
    // 添加
    createOrUpdate(name) {
      this.$refs[name].validate(valid => {
        this.dataInfo.ticket_id = this.ticket_id;
        if (valid) {
          if (this.dataInfo.id == null || this.dataInfo.id == 0) {
            this.$api.smartticketprice.create(this.dataInfo).then(res => {
              if (res.code == 200) {
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showModalStatus = !this.showModalStatus;
            });
          } else {
            this.$api.smartticketprice.edit(this.dataInfo).then(res => {
              if (res.code == 200) {
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showModalStatus = !this.showModalStatus;
            });
          }
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 删除
    remove: function(id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.smartticketprice.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList();
            }
          });
        }
      });
    },
    // 翻页
    changePage() {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function(name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.smartticketprice.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
    }
  }
};
</script>

<style scoped>
</style>